export default `
:host {
  display: flex;
  width: 100%;
  font-size: 16px;
}
:host * {
  box-sizing: border-box;
}
:host video {
  width: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9idWlsZGhvbWUvcmVwby9hcHAvY29tcG9uZW50cy9yZWNvcmRpbmctY2FudmFzIiwic291cmNlcyI6WyJyZWNvcmRpbmctY2FudmFzLmNvbXBvbmVudC5zY3NzIiwiLi4vLi4vLi4vc2Nzcy9taXhpbnMvYmFzZS1jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQTtFQUNFO0VBQ0E7RUNDQTs7QUFKQTtFQUNFOztBRE1GO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyJAaW1wb3J0ICcuLi8uLi8uLi9zY3NzL3VpLWtpdCc7XG5cbjpob3N0IHtcbiAgZGlzcGxheTogZmxleDtcbiAgd2lkdGg6IDEwMCU7XG5cbiAgQGluY2x1ZGUgYmFzZS1jb21wb25lbnQoKTtcblxuICB2aWRlbyB7XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cbn1cbiIsIkBtaXhpbiBiYXNlLWNvbXBvbmVudCgpIHtcbiAgKiB7XG4gICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgfVxuXG4gIGZvbnQtc2l6ZTogMTZweDtcbn1cbiJdfQ== */`;
